import React, { PureComponent } from "react"
import { withRouter } from "react-router-dom"
import { Modal, Form, Segment, Button, Header, Message } from "semantic-ui-react"
import axios from "axios"

import { rand } from '../../utils/rand'

const getToken = async (username, password) => {
  try {
    const response = await axios.post(
      "https://data.visp.net/authenticate",
      {
        username: username,
        password: password
      },
      {
        headers: {
          "Content-Type": "application/json",
          "Visp-agent": "ubo-web"
        }
      }
    )
    return response
  } catch (err) {
    return err
  }
}

class Login extends PureComponent {
  state = { open: false, error: false, isLoading: false }

  handleSubmit = async event => {
    event.preventDefault()
    const invalidLoginInfo = 'error:InvalidLoginInfo:Incorrect username or password'
    const noUserCredentials = 'error:NoUserCredentials:Accessing the UBO Client requires the username and password'
    const { username, password } = this.state
    const { history, location } = this.props
    this.setState({ isLoading: true })
    if (
      username === undefined || password === undefined ||
      (await getToken(username, password)).data === invalidLoginInfo ||
      (await getToken(username, password)).data === noUserCredentials
    ) {
      this.setState({ error: true, isLoading: false, errMsg: false })
    } else {
      try {
        if ((await getToken(username, password)).data.token) {
          const { token, payload } = (await getToken(username, password)).data
          const { exp, loggedInAs } = payload
          const randObject = rand(false, token, exp, loggedInAs)
          // this.props.log(true)
          this.props.onClose()
          this.setState(prevState => ({ open: !prevState.open, isLoading: false }))
          localStorage.setItem("Visp.token", token)
          localStorage.setItem("Visp.token-expiry", exp)
          localStorage.setItem("Visp.logged-in-as", randObject.value)
          localStorage.setItem("_rnkey", randObject.randomNumKey)
          localStorage.setItem("_utype", loggedInAs)
          history.push(location.pathname)
        }
      } catch (err) {
        console.log('Login Error: ', err)
        this.setState({ error: true, isLoading: false, errMsg: true })
      }
    }
  }

  handleInput = ({ target: { value, name } }) => {
    this.setState({ [name]: value, error: false })
  }

  handleCloseModal = () => {
    this.setState({ open: false, error: false })
    this.props.onClose()
  }

  render = () => {
    const { error, isLoading, errMsg } = this.state
    const isLoggedIn = localStorage.getItem("Visp.logged-in-as") === rand(true)
    return (
      <Modal
        dimmer
        size="mini"
        open={this.props.open}
        onClose={this.handleCloseModal}
      >
        <Header as="h2" color="blue" textAlign="left">
          <Header.Content>{isLoggedIn ? "You are currently logged in." : "Login"}</Header.Content>
        </Header>
        {!isLoggedIn && (
          <Form error={error} size="large" onSubmit={this.handleSubmit}>
            <Segment stacked>
              <Form.Input
                fluid
                icon="user"
                iconPosition="left"
                placeholder="Username"
                name="username"
                error={error}
                onChange={this.handleInput}
              />
              <Form.Input
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                name="password"
                error={error}
                onChange={this.handleInput}
              />
              {errMsg && /* ? (
                <Message error content='Server is currently down. Unable to fetch token. Please try again later.' />
              ) : */ (
                  <Message error content='Username or Password is incorrect' />
                )}
              <Button loading={isLoading} type="submit" color="blue" fluid size="large">
                Login
              </Button>
            </Segment>
          </Form>
        )}
      </Modal>
    )
  }
}

export default withRouter(Login)
